import { Environment } from '@abp/ng.core';

const baseUrl = 'https://localhost:4200';
const adv_pagertime = 30000;

export const environment = {
  remoteEnv:{
    url:'config.json',
    mergeStrategy:"deepmerge",

  },
  production: false,
  application: {
    baseUrl,
    name: 'KKISServer',
    logoUrl: ''
  },
  oAuthConfig: {
    issuer: 'https://localhost:44380',
    redirectUri:  window.location.origin+"/article",
    silentRefreshUri:  window.location.origin + '/silent-refresh.html',
    useSilentRefresh:true,
    silentRefreshTimeout:5000,
    clearHashAfterLogin: true,
    nonceStateSeparator : 'semicolon',
    clientId: 'kkis.webshop',
    responseType: 'code',
    dummyClientSecret:"secret",
    scope: 'offline_access openid profile email phone WebshopAPI',
    requireHttps: true,
    showDebugInformation:true
  },
  apis: {
    default: {
      url: 'https://localhost:44380',
      rootNamespace: 'KKIS.KKISServer',
    },
  },
  setting: {
    adv_pagertime
  }
} as Environment;
